import type { IGraphQLQuery } from '@libs/graphQL/types'
import type {
  Mutation,
  UpdateApplicationSettingsMutationArgs
} from '../typeDefs/types'

export type MutationUpdateApplicationSettings = IGraphQLQuery<
  UpdateApplicationSettingsMutationArgs,
  Pick<Mutation, 'updateApplicationSettings'>
>

export const mutationUpdateApplicationSettings = `
  mutation mutationUpdateApplicationSettings(
    $applicationSettings: InputUpdateApplicationSettings!
  ) {
    updateApplicationSettings(
      applicationSettings: $applicationSettings
    ) {
      userRegistration
      activityLogsIsActive
      activityLogsRetentionDurationInMonth
      tls

      defaultProfileId
      defaultRoleIds
      telemetryEnabled
      ioaAutomaticConfiguration
      cloudStatisticsIsActive
      healthCheckGlobalStatusDisplayEnabled

      # SMTP configuration

      smtpAuthenticationMethod
      smtpRelayId
      smtpRelayUuid

      # Basic SMTP server configuration

      smtpServerAddress
      smtpServerPort
      smtpAccount
      smtpAccountPassword
      smtpIsAccountPasswordDefined
      smtpUseStartTLS
      emailSender

      # Office365 SMTP configuration

      smtpOffice365TenantId
      smtpOffice365ClientId
      smtpOffice365Secret
      smtpIsOffice365SecretDefined
      smtpOffice365SenderEmail
      smtpOffice365SenderName
    }
  }
`
